import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import UserDateFormat from '../../../../../../components/user-date-timezone-format';
import { messages } from '../../../messages';

import type { PickListGridItem } from '../pick-list-grid';

type LastModifiedCellProps = {
  row: { original: PickListGridItem };
};

const LastModifiedCell = ({ row }: LastModifiedCellProps) => {
  const { shared, modifyDate } = row.original;
  if (shared || !modifyDate) {
    return null;
  }
  return <UserDateFormat dateTime={modifyDate} />;
};

export const createLastModifiedColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'modifyDate',
  Header: <FormattedMessage {...messages.gridColLastModifiedDate} />,
  Cell: LastModifiedCell,
  width: 1.25,
});
